import {getMethod} from '~/api'
import {appInstance} from '@/utils/app-accessor'

async function get(request) {
    return await getMethod('/proxy/google/geocode', {
        ...request,
        language: appInstance.$i18n.locale.value,
    })
}

export {get}
